import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { Arrow } from "@faire/web/slate/icons/foundation/Arrow";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import { useSelfServeContext } from "../../hooks/useSelfServeContext";
import { findPathsFromSelectedNode } from "../../utils/findPathsFromSelectedNode";
import { LinkedHelpCenterButtonWrapper, LinkedSingleHelpCenterButtonWrapper } from "./styles";
export var LinkedHelpCenterButton = function LinkedHelpCenterButton(_ref) {
  var searchableNode = _ref.searchableNode,
    onClick = _ref.onClick;
  var _useSelfServeContext = useSelfServeContext(),
    context = _useSelfServeContext.context;
  var tree = context.tree;
  var nodePaths = findPathsFromSelectedNode(tree, searchableNode).filter(function (node) {
    return node.id !== "Root";
  });
  return /*#__PURE__*/React.createElement(LinkedHelpCenterButtonWrapper, {
    onClick: onClick
  }, nodePaths.map(function (node, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: node.id
    }, /*#__PURE__*/React.createElement(LinkedSingleHelpCenterButtonWrapper, null, /*#__PURE__*/React.createElement(Typography, null, node.label)), /*#__PURE__*/React.createElement(Spacer, {
      width: "1x"
    }), index !== nodePaths.length - 1 ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Arrow, {
      direction: "right"
    }), /*#__PURE__*/React.createElement(Spacer, {
      width: "1x"
    }))) : null);
  }));
};